<script setup>
import Swal from 'sweetalert2'

const route = useRoute()
const config = useRuntimeConfig()

definePageMeta({
  theme: 'theme-lapiz',
  middleware: ['validate-session']
})

useHead(() => ({
  link: [
    {
      rel: 'canonical',
      href: config.public.SEO_APP_ROOT
    }
  ]
}))

onMounted(() => {
  if (route.query?.sayThanks) {
    Swal.fire({
      title: 'Thank you!',
      html: 'We appreciate you letting us know. ',
      confirmButtonText: 'Close'
    })
  }
})
</script>

<template>
  <div
    id="top"
    class="bg-white dark:bg-transparent">
    <HomeHeader v-if="config.public.CERT_DASHBOARD_ENABLED" />
    <HomeHeaderOld v-else />

    <HomeHero />
    <HomePitch />
    <HomeBenefits />
    <HomeCertificationsAvailable />
    <HomeUpcomingCertifications />
    <HomePoll />
    <HomeTailored />
    <HomeTestimonial />
    <HomePress />
    <HomeLead />
    <HomeFooter />
  </div>
</template>
